import {view, Icon, Divider, Menu, MenuItem, Button, tokens} from '@sail/ui';
import {assignProps} from '@sail/engine';
import {more, product} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';

type ProductCardProps = {
  productId: string;
  productName: string | undefined | null;
  price?: number | undefined | null;
  currency?: string | undefined | null;
  image?: string | undefined | null;
};

const messages = defineMessages({
  cardTitle: {
    id: 'conversations_ui.product_card.title',
    description: 'Product Card title',
    defaultMessage: 'Product',
  },
});

export const ProductCard = ({
  productId,
  productName,
  price,
  currency,
  image,
}: ProductCardProps) => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 'medium',
        padding: 'space.150',
        borderColor: 'border',
        borderWidth: 1,
        borderStyle: 'solid',
        maxWidth: '500px',
        position: 'relative',
      }}
    >
      {image ? (
        <view.img
          src={image}
          alt={intl.formatMessage(messages.cardTitle)}
          css={{
            height: '48px',
            width: '48px',
            marginRight: 'space.150',
            borderRadius: 'small',
          }}
        />
      ) : (
        <view.div
          css={{
            width: '48px',
            height: '48px',
            borderRadius: 'small',
            backgroundColor: 'offset',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: 'space.150',
          }}
        >
          <Icon
            icon={product}
            size="small"
            css={{color: tokens.color.neutral[200].toString()}}
          />
        </view.div>
      )}
      <view.div
        css={{
          stack: 'y',
          gap: 'xxsmall',
        }}
      >
        <view.div css={{stack: 'x', gap: 'small'}}>
          <view.span
            css={{
              color: 'subdued',
              font: 'label.medium.emphasized',
            }}
          >
            {intl.formatMessage(messages.cardTitle)}
          </view.span>
          {productName ? (
            <view.div css={{height: 10, stack: 'x', width: 0}}>
              <Divider />
            </view.div>
          ) : null}
          {productName ? (
            <view.span
              css={{
                color: 'subdued',
                font: 'label.medium',
              }}
            >
              {productName}
            </view.span>
          ) : null}
        </view.div>
        <Menu
          trigger={
            <Button
              css={{
                boxShadow: 'none',
                position: 'absolute',
                top: 8,
                right: 8,
              }}
            >
              <Icon icon={more} size="small" css={{color: 'subdued'}} />
            </Button>
          }
          subviews={{popover: {uses: [assignProps({placement: 'top'})]}}}
        >
          <MenuItem href={`https://dashboard.stripe.com/products/${productId}`}>
            Edit
          </MenuItem>
        </Menu>
        {price && currency ? (
          <view.span
            css={{
              font: 'heading.large',
            }}
          >
            {intl.formatNumber(price / 100, {
              style: 'currency',
              currency,
            })}
          </view.span>
        ) : null}
      </view.div>
    </view.div>
  );
};
